import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Badge,
  Card,
  CardBody,
} from "reactstrap";

const InfoItem = ({ label, value }) => (
  <div className="mb-3">
    <div className="text-muted small">{label}</div>
    <div className="fw-semibold">{value || "-"}</div>
  </div>
);

const SectionCard = ({ title, children }) => (
  <Card className="shadow-sm border-0 mb-3">
    <CardBody>
      <h6 className="mb-3 text-primary fw-bold">{title}</h6>
      {children}
    </CardBody>
  </Card>
);

const RankedViewModal = ({ isOpen, toggle, data }) => {
  if (!data) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle} className="border-0">
        تفاصيل البطولة
      </ModalHeader>

      <ModalBody className="pt-0">
        {/* Main Info */}
        <SectionCard title="المعلومات الأساسية">
          <Row>
            <Col md={6}>
              <InfoItem label="الاسم" value={data.name} />
            </Col>

            <Col md={6}>
              <InfoItem label="الكود" value={data.code} />
            </Col>

            <Col md={6}>
              <InfoItem label="عدد اللاعبين" value={data.maxPlayers} />
            </Col>

            <Col md={6}>
              <InfoItem label="عدد الأسئلة" value={data.questionCount} />
            </Col>

            <Col md={6}>
              <InfoItem
                label="وقت السؤال"
                value={`${data.timePerQuestionSec} ثانية`}
              />
            </Col>

            <Col md={6}>
              <div className="mb-3">
                <div className="text-muted small">الحالة</div>
                <Badge
                  color={data.isActive ? "success" : "danger"}
                  className="px-3 py-2"
                >
                  {data.isActive ? "نشطة" : "غير نشطة"}
                </Badge>
              </div>
            </Col>
          </Row>
        </SectionCard>

        {/* Host */}
        <SectionCard title="صاحب الغرفة">
          <InfoItem label="الاسم" value={data.host?.fullName} />
          <InfoItem label="البريد الإلكتروني" value={data.host?.email} />
        </SectionCard>

        {/* Categories */}
        {/* <SectionCard title="التصنيفات">
          <Row>
            <Col md={4}>
              <InfoItem label="التصنيف الأول" value={data.category_1?.name} />
            </Col>
            <Col md={4}>
              <InfoItem label="التصنيف الثاني" value={data.category_2?.name} />
            </Col>
            <Col md={4}>
              <InfoItem label="التصنيف الثالث" value={data.category_3?.name} />
            </Col>
          </Row>
        </SectionCard> */}

        {/* Dates */}
        <SectionCard title="التواريخ">
          <Row>
            <Col md={6}>
              <InfoItem
                label="تاريخ الإنشاء"
                value={new Date(data.createdAt).toLocaleString()}
              />
            </Col>

            <Col md={6}>
              <InfoItem label="الحالة الحالية" value={data.status} />
            </Col>
          </Row>
        </SectionCard>
      </ModalBody>
    </Modal>
  );
};

export default RankedViewModal;
